import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import NewArticleCard from "../components/NewArticleCard";
import { getPublishedArticles } from "../server/api";
import { parseJournalPath } from "../utils/formatJournalPath";
const IssueDetailPage = () => {
  const { jcr, volumeId, issueId } = useParams();
  const parsedJcr = parseJournalPath(jcr);
  const [issueData, setIssueData] = useState(null);
  const [volumeInfo, setVolumeInfo] = useState(null);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    handleIssueData();
    // if(parsedJcr === "Current Pharmaceutical Analysis" && volumeId === "21"){
    //   localStorage.setItem("jcrImg",`/images/issnue/CPA_21/${issueId}.jpg`);
    // }
  }, [parsedJcr, volumeId, issueId]);

  // 对应期刊文章数据请求
  const handleIssueData = async () => {
    try {
      const response = await getPublishedArticles({
        "jcr": ["CURRENT PHARMACEUTICAL ANALYSIS", "CURRENT MOLECULAR PHARMACOLOGY", "CURRENT Genomics"],
        "page": 1,
        "limit": 8,
        "order": "",
        "years": [],
        "opt": "issue",
        "vol": volumeId,
        "issued": issueId,
      });
      setArticles(response.data);
    } catch (error) {
      setError(error.message);
    } finally {
      setLoading(false);
    }
  }

  if (loading) {
    return (
      <div className="container mt-4">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-2">Loading issue details...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mt-4">
        <div className="alert alert-danger" role="alert">
          <h4 className="alert-heading">Error Loading Issue</h4>
          <p>{error}</p>
          <Link to="/archives" className="btn btn-primary">
            Back to Archives
          </Link>
        </div>
      </div>
    );
  }

  // 期刊封面映射
  const journalCoverMap = {
    "Current Pharmaceutical Analysis": "/images/journals/cpa.jpg",
    "Current Molecular Pharmacology": "/images/journals/cmp.jpg",
    "Current Genomics": "/images/journals/cg.jpg",
  };


  return (
    <div className="container mt-4 fade-in-up">
      {/* 面包屑导航 */}
      <nav aria-label="breadcrumb" className="mb-4">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/archives">Archives</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to={`/archive/${jcr}`}>{parsedJcr}</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            {`Issue ${issueId} of Volume ${volumeId}`}
          </li>
        </ol>
      </nav>

      {/* 期刊头部信息 */}
      <div className="row mb-5">
        <div className="col-md-3">
          <img
            src={journalCoverMap[parsedJcr] || "/images/journals/vg.jpg"}
            alt="default"
            className="img-fluid rounded shadow"
            alt={articles.parsedJcr}
          />
        </div>
        <div className="col-md-9">
          <div className="issue-header">
            <h1 className="display-6 mb-2">
              {`Volume ${volumeId}`} - {`Issue ${issueId}`}
            </h1>
            <div className="issue-meta mb-3">
              <div className="row">
                <div className="col-sm-6">
                  <p className="mb-1">
                    <i className="fas fa-file-alt me-2"></i>
                    <strong>Articles:</strong> {articles.length}
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-1">
                    <i className="fas fa-book me-2"></i>
                    <strong>Volume:</strong> {volumeId}
                  </p>
                </div>
                <div className="col-sm-6">
                  <p className="mb-1">
                    <i className="fas fa-book me-2"></i>
                    <strong>Year:</strong>2025
                  </p>
                </div>
              </div>
            </div>

            <p className="lead">Volume:{volumeId} includes {issueId} issue{articles.length > 1 ? "s" : ""}</p>
          </div>
        </div>
      </div>

      {/* 文章列表 */}
      <div className="row">
        <div className="col-12">
          <h3 className="mb-4">Articles in this Issue</h3>

          {articles.length === 0 ? (
            <div className="alert alert-info">
              <p className="mb-0">No articles available for this issue.</p>
            </div>
          ) : (
            <div className="articles-list">
              {articles.map((article, index) => (
                <NewArticleCard key={index} article={article} index={index + 1} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default IssueDetailPage;
